import React from 'react';
import './PageSlug.css';

function PageSlug({ title, subtitle, children, brand, className, h3title }) {
    const slugClass = `page-slug ${className || ''}`;
    const titleClass = brand ? 'brand-color' : null;

    return (
        <section className={slugClass}>
            {title && <h1 className={titleClass} dangerouslySetInnerHTML={{ __html: title }} />}
            {subtitle && <h2 dangerouslySetInnerHTML={{ __html: subtitle }} />}
            {h3title && <h3 dangerouslySetInnerHTML={{ __html: h3title }} />}
            {children}
        </section>
    );
}

export default PageSlug;
